import { makeStyles, Theme } from '@material-ui/core/styles';

const drawerWidth = 240;

export const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: theme.zIndex.drawer + 1,
    background: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[0],
    fontWeight: 550,
    [theme.breakpoints.down('sm')]: {
      zIndex: theme.zIndex.drawer + 3,
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxShadow: theme.shadows[0],
    borderColor: 'transparent',
  },
  drawerOpen: {
    width: drawerWidth,
  },
  drawerClose: {
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.down('sm')]: {
      width: 0,
      display: 'none',
    },
  },
  drawerMobile: {
    [theme.breakpoints.down('sm')]: {
      width: '280px',
      '& .MuiDrawer-paper': {
        width: '280px',
        position: 'fixed',
        height: '100vh',
        zIndex: theme.zIndex.drawer + 2,
      },
    },
  },

  listItemIcon: {
    minWidth: 0,
    marginRight: theme.spacing(2),
    justifyContent: 'center',
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    margin: theme.spacing(1),
    fontWeight: 600,
    fontFamily: 'Roboto',
    fontSize: '20px',
    lineHeight: '27px',
  },
  appBarSpacer: theme.mixins.toolbar,
  toolbarHead: {
    position: 'relative',
    paddingLeft: theme.spacing(2),
    height: theme.spacing(8),
  },
  toolbarIcon: {
    position: 'absolute',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
  },
  activeListItem: {
    color: theme.palette.info.main,
    fontSize: '18px',
  },
  // listItemIcon: {
  //   minWidth: theme.spacing(5.5),
  // },
  activeListItemIcon: {
    '& svg': {
      fill: theme.palette.info.main,
    },
  },
  badge: {
    background: theme.palette.info.main,
  },
  navBar: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    height: '100%',
  },
  version: {
    position: 'absolute',
    bottom: 10,
    left: 20,
    color: theme.palette.grey[600],
  },
  listTextStyling: {
    '& .MuiTypography-body1': {
      fontSize: '18px !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px !important',
      },
    },
  },
  mobileListItem: {
    [theme.breakpoints.down('sm')]: {
      padding: '8px 16px',
      minHeight: '48px',
    },
  },
  mobileListItemIcon: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '40px',
      marginRight: '12px',
    },
  },
}));
